var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "item-icon",
    focusable: "false",
    "aria-labelledby": titleId,
    role: "img",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#107C41",
    d: "M9 3h9.586c.265 0 .52.105.707.293l6.415 6.414a1 1 0 01.293.707V26A3.002 3.002 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87BDA0",
    d: "M19.286 3.286l6.422 6.421a.994.994 0 01.203.293H21a2.001 2.001 0 01-1.995-1.85L19 8V3.09c.105.048.202.114.286.196z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.25 25a.748.748 0 00.75-.75v-10.5a.748.748 0 00-.75-.75H12a.748.748 0 00-.75.75v1.5h-1.5A.748.748 0 009 16v6a.748.748 0 00.75.75h1.5v1.5A.748.748 0 0012 25h8.25zm-4.5-9.75H12v-1.5h3.75v1.5zm4.5 0H16.5v-1.5h3.75v1.5zm0 3H16.5V16h3.75v2.25zm-8.344 3.188h-1.511l1.582-2.45-1.442-2.425h1.518l.756 1.494.82-1.494h1.43l-1.483 2.42 1.518 2.454H13.6l-.838-1.564-.856 1.564zm8.344-.188H16.5V19h3.75v2.25zm0 3H16.5V22h3.75v2.25zm-4.5 0H12v-1.5h3.75v1.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.9f9fd0f5c12a000b3a790700c7380f3d.svg";
export { ForwardRef as ReactComponent };